import Vue, { ComponentOptions } from 'vue'

import ChatxModule from '@/components/chatx/chatx/chatx.module'
// eslint-disable-next-line import/extensions

import ChatSolicitacaoComentario from './chat-solicitacao-comentario.vue'

export default {
  components: {
    ...ChatxModule.exportComponents,
  },
  exportComponents: {
    ChatSolicitacaoComentario,
  },
} as ComponentOptions<Vue> & Export

type Export = { exportComponents?: any }
